import { makeContext } from '../../utils'

const PlanModalOpenContext = makeContext(false, 'PlanModalOpenContext')

export default PlanModalOpenContext
